import { render, staticRenderFns } from "./AdvancedSetting.vue?vue&type=template&id=1f9b7ae8&scoped=true"
import script from "./AdvancedSetting.vue?vue&type=script&lang=js"
export * from "./AdvancedSetting.vue?vue&type=script&lang=js"
import style0 from "./AdvancedSetting.vue?vue&type=style&index=0&id=1f9b7ae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9b7ae8",
  null
  
)

export default component.exports